import { SortParams } from '../../../typings/grid';
import { MarketerProduct } from '../../../typings/marketers';

export const ADD_INTERNAL_MARKETER_PRODUCT = 'ADD_INTERNAL_MARKETER_PRODUCT';
export type ADD_INTERNAL_MARKETER_PRODUCT = typeof ADD_INTERNAL_MARKETER_PRODUCT;

export interface AddInternalMarketerProduct {
    type: ADD_INTERNAL_MARKETER_PRODUCT;
    product: MarketerProduct;
    productsSortParams?: SortParams;
}

export function addInternalMarketerProductAction(
    product: MarketerProduct,
    productsSortParams?: SortParams
): AddInternalMarketerProduct {
    return {
        type: ADD_INTERNAL_MARKETER_PRODUCT,
        product,
        productsSortParams
    };
}
